module.exports = __webpack_public_path__ + "img/o.7a1098b4.jpg";